import React from 'react';
import { useLocation } from 'react-router-dom';
import Header from './ui/Header';
import SEO from './SEO';
import { getBaseJsonLd, SEO as SEO_CONFIG } from '../config/seo';

const ROUTE_SEO = {
  '/caterer-discovery': {
    title: 'Find Caterers & Restaurants for Events | Food Delivery South Africa',
    description:
      'Search verified caterers and restaurants for weddings, funerals, corporate events across South Africa. Wedding catering Johannesburg, Cape Town, Durban, Pretoria. Like Uber Eats and Mr D Food for events—find and book caterers near you.',
    keywords:
      'find caterers, find caterers South Africa, caterers Johannesburg, caterers Cape Town, event catering, wedding catering, funeral catering, corporate catering, food delivery events, Uber Eats Mr D Food alternative, catering South Africa, verified caterers, book caterer',
  },
  '/custom-request': {
    title: 'Request Custom Catering | Special Event Food South Africa',
    description:
      'Submit a custom catering request. Verified caterers send quotes for wedding, funeral, corporate and traditional events across South Africa. Custom catering Johannesburg, Cape Town, Durban, Pretoria. Special event food delivery.',
    keywords:
      'custom catering, special event catering, catering request, wedding catering quote, funeral catering quote, corporate catering quote, traditional catering South Africa, African catering, Lobola catering, catering Johannesburg, catering Cape Town',
  },
  '/contact-us': {
    title: 'Contact Mrs Cater',
    description:
      'Contact Mrs Cater for catering bookings, caterer verification, and platform support. Customer service for event catering, wedding catering, funeral catering and corporate catering across South Africa.',
    keywords: 'contact Mrs Cater, catering support South Africa, event catering help, customer service catering',
  },
  '/caterer-verification': {
    title: 'Caterer Verification | How Mrs Cater Verifies Caterers',
    description:
      'How Mrs Cater verifies caterers for event catering in South Africa. Trust and safety for wedding catering, funeral catering, corporate catering. Verified caterers Johannesburg, Cape Town, Durban, Pretoria.',
    keywords: 'caterer verification, verified caterers South Africa, trusted caterers, catering trust and safety',
  },
  '/trust-score': {
    title: 'Trust Score | How We Score Caterer Reliability',
    description:
      'How Mrs Cater scores caterer reliability, quality and response time. Transparent trust for event catering, wedding catering, funeral catering and corporate catering in South Africa.',
    keywords: 'trust score, caterer ratings South Africa, catering reviews, reliable caterers',
  },
  '/payments': {
    title: 'Payments | Secure Catering Payments South Africa',
    description:
      'Secure payments for event catering in South Africa. Your money is protected until delivery. Safe payment for wedding catering, funeral catering, corporate catering bookings.',
    keywords: 'secure catering payment, catering payment South Africa, safe payment events',
  },
  '/terms-of-service': {
    title: 'Terms of Service',
    description: 'Mrs Cater terms of service for customers and caterers. Event catering, wedding catering, funeral catering, corporate catering platform terms.',
    keywords: 'terms of service, Mrs Cater terms, catering platform terms',
  },
  '/privacy-policy': {
    title: 'Privacy Policy',
    description: 'Mrs Cater privacy policy. How we use and protect your data for event catering, wedding catering, funeral catering and corporate catering services.',
    keywords: 'privacy policy, Mrs Cater privacy, data protection catering',
  },
  '/refund-policy': {
    title: 'Refund & Cancellation Policy',
    description: 'Mrs Cater refund and cancellation policy for catering bookings. Wedding catering, funeral catering, corporate catering refunds across South Africa.',
    keywords: 'refund policy, cancellation policy catering, catering refund South Africa',
  },
  '/compliance': {
    title: 'Compliance',
    description: 'Mrs Cater compliance and regulatory information for event catering services in South Africa.',
    keywords: 'compliance, catering compliance South Africa',
  },
  '/submit-idea': {
    title: 'Submit an Idea',
    description: 'Share your ideas to improve Mrs Cater. Event catering, wedding catering, funeral catering and corporate catering platform feedback.',
    keywords: 'submit idea, Mrs Cater feedback, catering platform feedback',
  },
  '/report-problem': {
    title: 'Report a Problem',
    description: 'Report an issue with a catering booking or the Mrs Cater platform. Support for event catering, wedding catering, funeral catering and corporate catering.',
    keywords: 'report problem, catering support, Mrs Cater help',
  },
  '/delete-account': {
    title: 'Delete account',
    description: 'Permanently delete your Mrs Cater customer account and associated data.',
    keywords: 'delete account, Mrs Cater account',
  },
  '/bid-comparison': {
    title: 'Compare Caterer Bids | Event Catering Quotes South Africa',
    description:
      'Compare bids from verified caterers for your event. Wedding catering, funeral catering, corporate catering quotes. Compare caterers Johannesburg, Cape Town, Durban, Pretoria.',
    keywords:
      'compare caterer bids, catering quotes South Africa, wedding catering quotes, funeral catering quotes, corporate catering quotes, compare caterers',
  },
};

function Layout({ children }) {
  const { pathname } = useLocation();
  const base = pathname.split('/').slice(0, 2).join('/') || '/';
  const exact = pathname.endsWith('/') && pathname.length > 1 ? pathname.slice(0, -1) : pathname;
  const config = ROUTE_SEO[exact] || ROUTE_SEO[base] || {};
  // Normalized canonical: no trailing slash (avoids "Duplicate without user-selected canonical")
  const canonicalPath = pathname === '/' || pathname === '' ? '/' : pathname.replace(/\/+$/, '');
  const noindex = exact === '/delete-account';

  return (
    <div className="min-h-screen min-h-[100dvh] bg-background overflow-x-hidden">
      <SEO
        title={config.title}
        description={config.description}
        keywords={config.keywords || SEO_CONFIG.keywords}
        canonical={canonicalPath}
        noindex={noindex}
        jsonLd={getBaseJsonLd()}
      />
      <Header />
      <main className="pt-20 min-h-[calc(100dvh-5rem)] overflow-x-hidden">
        {children}
      </main>
    </div>
  );
}

export default Layout;
